import React from "react";
import { Flex } from "../../Flex";
import { position, space, SpaceProps } from "styled-system";
import { ContactConfig } from "../../../types/ContactConfig";
import styled from "styled-components";
import { Line } from "../../Line";
import { NewContactDetails } from "./_/NewContactDetails";
import { ContactDetails } from "../../../types/ContactDetailsValues";
import kebabCase from "lodash/kebabCase";
import { AssignRoleRadioButtonGroup } from "./_/AssignRoleRadioButtonGroup";
import {
  combineRolesContactConfig,
  mapAssignedRolesAsHeader,
  shouldDisplayNewContactDetailsForm,
} from "./_/utils/AssignedRolesUtils";

export const ContactRoleHeader = styled.span<SpaceProps>`
  ${space}
  ${position}
  display: inline-block;
  font-size: ${({ theme }) => theme.fontSizes[4]};
  line-height: ${({ theme }) => theme.lineHeights[4]};
  font-weight: ${({ theme }) => theme.fontWeights.heavy};
`;

const sectionSeparator = (
  <Line
    my={5}
    width="100%"
    border="1px solid"
    borderColor="neutrals.ln30"
    bg="neutrals.ln30"
    opacity="1"
    height={0}
  />
);

interface Props {
  idPrefix: string;
  namePrefix: string;
  contactConfigs: ContactConfig[];
  contactDetails: ContactDetails[];
}

export const ContactDetailsAndRole: React.FC<Props & SpaceProps> = ({
  idPrefix,
  namePrefix,
  contactConfigs,
  contactDetails,
}) => {
  const mergedContactConfigs = combineRolesContactConfig(
    contactConfigs,
    contactDetails,
  );

  return (
    <>
      {mergedContactConfigs.map((contactConfig, contactIndex) => (
        <Flex
          flexDirection="column"
          key={`${idPrefix}.contacts[${contactIndex}]`}
        >
          <ContactRoleHeader mb={4}>
            {mapAssignedRolesAsHeader(
              contactDetails[contactIndex].role,
              contactDetails[contactIndex].roles,
            )}
          </ContactRoleHeader>
          {contactConfig.canAssignToAnother && (
            <AssignRoleRadioButtonGroup
              idPrefix={`${idPrefix}-radio-${kebabCase(contactConfig.role)}`}
              namePrefix={namePrefix}
              contactIndex={contactIndex}
              contactDetails={contactDetails}
              contactConfigs={mergedContactConfigs}
            />
          )}
          {shouldDisplayNewContactDetailsForm(
            contactConfig,
            contactDetails[contactIndex],
          ) && (
            <NewContactDetails
              idPrefix={`${idPrefix}-${kebabCase(contactConfig.role)}`}
              namePrefix={`${namePrefix}[${contactIndex}]`}
              contactConfig={contactConfig}
              contactDetails={contactDetails[contactIndex]}
            />
          )}
          {sectionSeparator}
        </Flex>
      ))}
    </>
  );
};

ContactDetailsAndRole.defaultProps = {};
